import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import BgTheme1 from '@/components/bg-theme-1.vue';
import ServiceSearchComponent from '@/components/search/service-search.vue';
import ServiceSearchResultComponent from '@/components/search/service-search-result.vue';
import {ServiceSearchResultComponentInterface} from '@/class/service-form.interface';
import InviteDetailComponent from '@/components/invite/invite-detail.vue';

@Component({
  components: {
    BgTheme1,
    ServiceSearchComponent,
    ServiceSearchResultComponent,
    InviteDetailComponent
  }
})
export default class SearchComponent extends Vue {
  searchToggle: boolean = false;
  step: number = 1;
  serviceType: number = 1;
  public serviceSearchResultComponent!: ServiceSearchResultComponentInterface;

  mounted() {
    // 1 = ผู้ให้บริการ
    let {serviceType} = this.$route.query;
    this.serviceType = parseInt(serviceType as string);
    this.serviceSearchResultComponent = this.$refs.serviceSearchResultComponent as unknown as ServiceSearchResultComponentInterface;
  }

  async searched() {
    this.step = 2;
    this.searchToggle = true;
    await this.serviceSearchResultComponent.fetchResult()
  }

  invited() {
    this.searchToggle = true;
    this.step = 3;
  }

  searchMoreClick() {
    this.searchToggle = false;
    this.step = 1;
  }
}


